import { useMentorModal } from '@/hooks/use-mentor-modal';
import type { TLocalize } from '@hooks/use-localize';

const MENTOR_VIDEO_URL =
    'https://player.vimeo.com/video/1143834262?h=c2c754eea1&badge=0&autopause=0&player_id=0&app_id=58479';

interface IProps {
    t: TLocalize;
}

const GuidancePanel = ({ t }: IProps) => {
    const { showModal: setMentorModalOpen } = useMentorModal();

    return (
        <div className="journey-panel">
            <div className="row">
                <div className="col-xs-12 col-sm-6">
                    <h2 className="journey-panel__title">
                        {t('DashLabel_NeedGuidance', 'Need Guidance?')}
                    </h2>
                    <div className="journey-panel__copy">
                        {t(
                            'DashLabel_IfYouNeedHelpInUnderstandingWhatItMeans',
                            "If you have questions about becoming a living donor or would like to speak with someone who has already gone through the donation process, we'd be happy to help connect you.",
                        )}
                    </div>
                    <a
                        href="#"
                        className="btn btn-nkr-red request-donor-mentor-button"
                        style={{ marginRight: 0, marginLeft: 0 }}
                        onClick={(e) => {
                            e.preventDefault();
                            setMentorModalOpen(true);
                        }}
                    >
                        {t('DashLabel_RequestADonorMentor', 'Request a Donor Mentor')}
                    </a>
                </div>
                <div className="col-xs-12 col-sm-6">
                    <iframe
                        className="journey-panel__video"
                        src={MENTOR_VIDEO_URL}
                        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        title="Donor Mentors"
                    ></iframe>
                </div>
            </div>
        </div>
    );
};

export default GuidancePanel;
